import { NgModule } from '@angular/core';
import { RouterModule, Routes, UrlSerializer } from '@angular/router';

//Resolver Service
import { anonPortalSettingsResolver } from './core/resolver/anon-portal-settings-resolver.service';
import { employeeInfoResolver } from './core/resolver/employee-info-resolver.service';
import { portalSettingsResolver } from './core/resolver/portal-settings-resolver.service';
import { portalModulesResolver } from './core/resolver/portal-modules-resolver.service';

//URL Custom Serialization
import { CustomUrlSerializer } from './url-serializer/custom-url-serializer';

//Layout Components
import { HomeLayoutComponent } from './layout/home-layout/home-layout.component';
import { OnboardingLayoutComponent } from './layout/onboarding-layout/onboarding-layout.component';
import { OfficeLayoutComponent } from './layout/office-layout/office-layout.component';
import { SmLayoutComponent } from './layout/sm-layout/sm-layout.component';
import { NotificationPageComponent } from './core/components/notification-page/notification-page.component';

//Note: Add new routing path all in lowercase
const routes: Routes = [
  //Pages using Default Layout
  {
    path: '',
    component: HomeLayoutComponent,
    resolve: {
      employee: employeeInfoResolver,
      portalSetting: portalSettingsResolver,
      portalModules: portalModulesResolver
    },
    children: [
      {
        path: '',
        redirectTo: 'home'
      },
      {
        path: 'admin',
        loadChildren: () => import('./pages/admin/admin.module').then(m => m.AdminModule)
      },
      {
        path: 'approval',
        loadChildren: () => import('./pages/approval/approval.module').then(m => m.ApprovalModule)
      },
      {
        path: 'aprouter',
        loadChildren: () => import('./pages/aprouter/aprouter.module').then(m => m.AprouterModule)
      },
      {
        path: 'checklist',
        loadChildren: () => import('./pages/checklist/checklist.module').then(m => m.ChecklistModule)
      },
      {
        path: 'crewtimecard',
        loadChildren: () => import('./pages/crew-timecard/crew-timecard.module').then(m => m.CrewTimecardModule)
      },
      {
        path: 'crew/timecard',
        loadChildren: () => import('./pages/crew-timecard/crew-timecard.module').then(m => m.CrewTimecardModule)
      },
      {
        path: 'employee',
        loadChildren: () => import('./pages/employee/employee.module').then(m => m.EmployeeModule)
      },
      {
        path: 'equipment',
        loadChildren: () => import('./pages/equipment/equipment.module').then(m => m.EquipmentModule)
      },
      {
        path: 'field',
        loadChildren: () => import('./pages/field/field.module').then(m => m.FieldModule)
      },
      {
        path: 'hiring',
        loadChildren: () => import('./pages/hiring/hiring.module').then(m => m.HiringModule)
      },
      {
        path: 'home',
        loadChildren: () => import('./pages/home/home.module').then(m => m.HomeModule)
      },
      {
        path: 'performance',
        loadChildren: () => import('./pages/performance/performance.module').then(m => m.PerformanceModule)
      },
      {
        path: 'plant',
        loadChildren: () => import('./pages/equipment/equipment.module').then(m => m.EquipmentModule)
      },
      {
        path: 'timeoff',
        loadChildren: () => import('./pages/timeoff/timeoff.module').then(m => m.TimeoffModule)
      },
      {
        path: 'timecardadmin',
        loadChildren: () => import('./pages/timecard-admin/timecard-admin.module').then(m => m.TimecardAdminModule)
      },
      {
        path: 'billing',
        loadChildren: () => import('./pages/billing/billing.module').then(m => m.BillingModule)
      },
      {
        path: 'issuetracker',
        loadChildren: () => import('./pages/issue-tracker/issue-tracker.module').then(m => m.IssueTrackerModule)
      }
    ],
  },
  //Pages using Onboarding Layout
  {
    path: '',
    component: OnboardingLayoutComponent,
    resolve: {
      portalSetting: anonPortalSettingsResolver
    },
    children: [
      {
        path: 'careers',
        loadChildren: () => import('./pages/careers/careers.module').then(m => m.CareersModule)
      }
    ]
  },
  //Pages using Office Tools Layout
  {
    path: '',
    component: OfficeLayoutComponent,
    resolve: {
      employee: employeeInfoResolver,
      portalSetting: portalSettingsResolver
    },
    children: [
      {
          path: 'office',
          loadChildren: () => import('./pages/office/office.module').then(m => m.OfficeModule)
      }
    ]
  },
  {
    path: '',
    component: SmLayoutComponent,
    resolve: {
      employee: employeeInfoResolver,
      portalSetting: portalSettingsResolver,
      portalModules: portalModulesResolver
    },
    children: [
      {
        path: 'sm',
        loadChildren: () => import('./pages/sm/sm.module').then(m => m.SMModule)
      }
    ]
  },
  //Pages with no Navbar
  {
    path: '',
    resolve: {
      employee: employeeInfoResolver,
      portalSetting: portalSettingsResolver
    },
    children: [
      {
        path: 'reportgateway',
        loadChildren: () => import('./pages/report-gateway/report-gateway.module').then(m => m.ReportGatewayModule)
      },
      {
        path: 'error',
        loadChildren: () => import('./pages/error/error.module').then(m => m.ErrorModule)
      }
    ]
  },
  //Pages using Login Layout
  {
    path: '',
    resolve: {
      portalSetting: anonPortalSettingsResolver
    },
    children: [
      {
        path: 'account',
        loadChildren: () => import('./pages/account/account.module').then(m => m.AccountModule)
      }
    ]
  }
];

@NgModule({
  declarations: [],
  imports: [
    RouterModule.forRoot(routes)
  ],
  providers: [
    {
      provide: UrlSerializer,
      useClass: CustomUrlSerializer
    }
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
